import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";
import { useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";




const InfoItem = ({ label, value }) => (
  <Row className="mb-4">
    <Col md={4} className="fw-semibold text-muted">
      {label}
    </Col>
    <Col md={8}>{value || <span className="text-muted">—</span>}</Col>
  </Row>
);

const SectionHeader = ({ title }) => (
  <h5 className="border-bottom pb-2 mb-4  text-primary fw-bold">{title}</h5>
);

const TenantDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await OrganizationService.tenantDetail(id);
      setData(response);
    } catch (error) {
      console.log("Failed to fetch tenant detail:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center align-content-center align-items-center justify-content-center">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!data) return null;

  const breadcrumbItems = [{ title: "Back To List ", link: "/tenant" }];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          title="Tenant Detail"
          pageTitle="Tenant Management"
          breadcrumbItems={breadcrumbItems}
        />
        <Card className="shadow-sm p-4">
          <CardBody>
            {/* ORGANIZATION INFORMATION */}
            <SectionHeader title="Organization Information" />
            <InfoItem label="Organization Name" value={data.organizationName} />
            <InfoItem label="Address" value={data.address1} />
            <InfoItem label="Contact Number" value={data.tel} />
            <InfoItem label="Email" value={data.email} />
            <InfoItem label="Created By" value={data.createdBy} />
            <InfoItem
              label="Created Date"
              value={
                data.createdDate
                  ? new Date(data.createdDate).toLocaleString()
                  : null
              }
            />

            {/* DATABASE INFORMATION */}
            <SectionHeader title="Database Information" />
            <InfoItem label="Host Name" value={data?.tenantInfo?.hostName} />
            <InfoItem label="Server" value={data?.tenantInfo?.server} />
            <InfoItem label="Database Name" value={data?.tenantInfo?.dbName} />
            <InfoItem label="Database User" value={data?.tenantInfo?.dbUser} />
            <InfoItem label="Database Password" value="**********" />
            <InfoItem label="Admin Email" value={data?.tenantInfo?.adminEmail} />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default TenantDetail;
